import React from "react"
import Icon from "@ant-design/icons"

const ChevronDownSVG = () => (
  <svg
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.35156 4.77344C4.5625 4.98438 4.91406 4.98438 5.125 4.77344L8.3125 1.58594C8.54688 1.35156 8.54688 1 8.3125 0.789062L7.79688 0.25C7.5625 0.0390625 7.21094 0.0390625 7 0.25L4.72656 2.52344L2.47656 0.25C2.26562 0.0390625 1.91406 0.0390625 1.67969 0.25L1.16406 0.789062C0.929688 1 0.929688 1.35156 1.16406 1.58594L4.35156 4.77344Z"
      fill="#4F4B4A"
    />
  </svg>
)

const ChevronDown = props => <Icon component={ChevronDownSVG} {...props} />

export default ChevronDown
